export interface IHttpRequestMetadata {
  encryptResponse?: boolean; // Client requests response encryption.
  isEncrypted?: boolean; // Payload sent to server is encrypted.
}

/** The metadata sent from client to server in the 'X-Request-Meta' header. */
export class HttpRequestMetadata {
  private requestIsEncrypted?: boolean;
  private encryptResponse?: boolean;

  /** Set if the payload sent to the server is encrypted. */
  public markPayloadEncrypted(): void {
    this.requestIsEncrypted = true;
  }

  /** Set to true if the client wants the response payload to be encrypted. */
  public requestEncryptedResponse(): void {
    this.encryptResponse = true;
  }

  /** Serialize to a plain object for JSON encoding. */
  public toJSON(): IHttpRequestMetadata {
    const output: IHttpRequestMetadata = {};
    if (this.requestIsEncrypted) output.isEncrypted = true;
    if (this.encryptResponse) output.encryptResponse = true;
    return output;
  }
}
